export default "__VITE_ASSET__DVTa0aXO__"